export function mergeClassNamesObj(obj1: Record<string, string>, obj2: Record<string, string>) {
  const objKeys = Object.keys(obj1).concat(Object.keys(obj2));

  return objKeys.reduce(
    (acc, key) => {
      acc[key] = [obj1[key], obj2[key]].filter(Boolean).join(' ');
      return acc;
    },
    {} as Record<string, string>,
  );
}
